import config from '../config';
import {
  customFetch,
  authHeader,
  jsonHeader,
  handleResponse,
  commonRequestOptions,
} from '../helpers';

const endpointPath = config.api.API_URL + '/setting';

export const settingService = {
  getAll,
  getAllForFrontend,
  update,
  sendTestEmail,
  rotateOidcSigningKey,
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function getAllForFrontend(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all_for_frontend`, requestOptions, signal).then(
    handleResponse
  );
}

function update(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function sendTestEmail(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/send_test_email`, requestOptions, signal).then(
    handleResponse
  );
}

function rotateOidcSigningKey(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/rotate_oidc_signing_key`, requestOptions, signal).then(
    handleResponse
  );
}
